module.exports = __webpack_public_path__ + "img/myguard_about_03.394015b4.png";